<template>
<div>
    <div v-for="s in sections">
        <div class="card mb-4 mt-4 form-section">
            <div class="card-header"><b>{{s['DisplayOrder']}}.0 {{s['SectionName']}}</b></div>
            <div class="card-body py-0">
                <div v-for="i in s['elements']" :key="i.InspectionSectionId+'.'+i.DisplayOrder" :class="{'inspection-result-title break-protect': true, 'alert-danger insp-result-non-compliant': (i.ComplianceStatusId == 2)}" :style="i.DisplayOrder == 1 ? 'border-top: 0px' : ''">
                    <div class="row py-2">
                        <div class="col-xl-6 col-lg-8 col-md-6 col-sm-12">
                            <span style="margin-right: 10px;">{{s['DisplayOrder']}}.{{i.DisplayOrder}}</span> {{ i.ElementText  }}
                        </div>

                        <div class="d-print-none col-xl-4 col-lg-12 col-md-4 col-sm-12 mb-lg-1 my-2 my-sm-2 my-md-0">
                            <b-badge variant="success" v-if="i.ComplianceStatusId == 1">{{ result_labels.compliant }}</b-badge>
                            <b-badge variant="danger" v-if="i.ComplianceStatusId == 2">{{ result_labels.noncompliant }}</b-badge>
                            <b-badge variant="secondary" v-if="i.ComplianceStatusId == 3 || (undefined == i.ComplianceStatusId)">N/A</b-badge>
                        </div>
                        <div class="d-none d-print-block col-xl-4 col-lg-12 col-md-4 col-sm-12 mb-lg-1 my-2 my-sm-2 my-md-0 mt-md-0 mt-1">
                            <label class="text-success" v-if="i.ComplianceStatusId == 1">{{ result_labels.compliant }}</label>
                            <label class="text-danger" v-if="i.ComplianceStatusId == 2">{{ result_labels.noncompliant }}</label>
                            <label v-if="i.ComplianceStatusId == 3 || (undefined == i.ComplianceStatusId)">{{ result_labels.na }}</label>
                        </div>

                        <div class="d-print-none col-xl-2 col-lg-6 col-md-2 col-sm-12 my-2 my-sm-0">
                            <router-link :to="'/inspections/result/'+i.InspectionResultId" title="View Result" v-if="i.InspectionResultId" class="btn btn-sm btn-light">
                                View Result
                            </router-link>
                        </div>
                    </div>

                    <div class="inspection-element-details" v-if="i.Comment || (i.files && i.files.length > 0) || (i.ComplianceStatusId == 2 && i.actions.length > 0)">
                        <div class="row mb-2" v-if="i.Comment">
                            <div class="col-xl-2 col-lg-3 col-12 mb-lg-0 mb-1 text-lg-right text-muted">
                                Comment:
                            </div>
                            <div class="col-xl-8 col-lg-9 col-12">
                                {{ i.Comment }}
                            </div>
                        </div>
                        <div class="row mb-2" v-if="i.total_positive_findings">
                            <div class="col-xl-2 col-lg-3 text-lg-right text-muted">
                                Positive Findings:
                            </div>
                            <div class="col-xl-8 col-lg-9 col-md-4 col-12">
                                {{ i.total_positive_findings }}
                            </div>
                        </div>
                        <div class="row mb-2" v-if="i.total_negative_findings">
                            <div class="col-xl-2 col-lg-6 text-lg-righ text-mutedt">
                                Negative Findings:
                            </div>
                            <div class="col-xl-8 col-lg-9 col-md-4 col-12">
                                {{ i.total_negative_findings }}
                            </div>
                        </div>
                        <div class="row mb-2" v-if="i.files && i.files.length > 0">
                            <div class="col-xl-2 col-12 mb-xl-0 mb-2 text-xl-right text-muted">
                                File(s) & Photo(s):
                            </div>
                            <div class="col-xl-8 col-12">
                                <file-list :files="i.files" />
                            </div>
                        </div>

                        <div class="row" v-if="i.ComplianceStatusId == 2 && i.actions.length > 0">
                            <div class="col-xl-2 col-12 mb-xl-0 mb-2 text-xl-right text-muted">
                                Corrective Action(s):
                            </div>
                            <div class="col-xl-8 col-12">
                                <corrective-action-table-list
                                    :actions="i.actions ? i.actions : []"
                                    view="cards"
                                    :hideActions="false"
                                    fileDisplayType="default" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <corrective-action-view-modal :ajaxMode="false" ref="correctiveActionViewModal" />
</div>
</template>

<script>
export default {

    props: {
        sections: {
            type: Array,
            default: () => [],
        },

        result_labels: {
            type: Object,
            default: () => ({
                compliant: 'Compliant',
                noncompliant: 'Non-Compliant',
                na: 'N/A',
            }),
        },
    },

    data: function() {
        return {}
    },

    methods: {
        togglePopup(element) {
            // Set the id for the modal
            this.$refs.correctiveActionViewModal.setModel(element.action || {});

            //Activate the modal
            this.$refs.correctiveActionViewModal.showModal();
        },

    },
    mounted() {

    }
}
</script>

<style scoped>
@media print {
    .form-section {
        page-break-before: always;
    }

    .break-protect {
        page-break-inside: avoid;
    }
}
</style>
